import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import * as ListBranchKeys from 'automation-ui-action-features/constants/ListBranchKeys';
import BranchMixin, { BranchMixinDefaultValues, branchFromJSON } from 'automation-ui-action-features/records/BranchMixin';
const ListBranchDefaultValues = Object.assign({}, BranchMixinDefaultValues, {
  [ListBranchKeys.BRANCH_NAME]: undefined,
  [ListBranchKeys.LIST_ID]: null,
  [ListBranchKeys.FILTER_BRANCH]: null
});
class ListBranch extends BranchMixin(createImmutableObjectClass(ListBranchDefaultValues, {
  fromJSON: json => Object.assign({}, json, branchFromJSON(json)),
  toJSON: branch => branch
})) {
  getListId() {
    return this.get(ListBranchKeys.LIST_ID);
  }
  setListId(listId) {
    return this.set(ListBranchKeys.LIST_ID, listId);
  }
  getFilterBranch() {
    return this.get(ListBranchKeys.FILTER_BRANCH);
  }
  setFilterBranch(newFilterBranch) {
    return this.set(ListBranchKeys.FILTER_BRANCH, newFilterBranch);
  }
  getBranchName() {
    return this.get(ListBranchKeys.BRANCH_NAME);
  }
  setBranchName(branchName) {
    return this.set(ListBranchKeys.BRANCH_NAME, branchName);
  }
}
export default ListBranch;